export default {
    cz: {
        stocksLast: 'Do vyprodání zásob',
        recommended: 'Doporučujeme',
        isRecent: 'Novinka',
        isFeatured: 'Výhodná cena',
        discount: 'Sleva',
    },
    sk: {
        stocksLast: 'Do vypredania zásob',
        recommended: 'Odporúčame',
        isRecent: 'Novinka',
        isFeatured: 'Výhodná ponuka',
        discount: 'Zľava',
    },
}
